import { InjectionToken } from '@angular/core';

export interface IAppMinimumVersionConfig {
  versionMismatchRoute: string;
  rootRoute: string;
  bypassValues: string[];
}

export const APPLICATION_MINIMUM_VERSION_CONFIG = new InjectionToken<IAppMinimumVersionConfig>( 'appMinimumVersion.config' );
